<template>
	<div class="transaction-item">
		<div class="transaction-row">
			<img :src="icon" :alt="merchantName" class="merchant-icon" @error="imageError = true" />
			<div class="transaction-details">
				<div class="transaction-info">
					<div class="merchant-info">
						<p class="merchant-name">{{ merchantName }}</p>
						<div class="amount-row">
							<span class="face-value">{{ formattedFaceValue }}</span>
							<span class="percentage">({{ formattedPercentage }}%)</span>
						</div>
					</div>
					<div class="cashback-badge">
						<img :src="require('@/assets/icons/coins-swap.png')" alt="cashback" class="cashback-icon" />
						<span class="cashback-amount">+{{ formattedCashback }}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="usedSavedToSpend" class="redeemed-row">
			<div class="redeemed-label">
				<img :src="require('@/assets/icons/coins-swap.png')" alt="redeemed" class="redeemed-icon" />
				<span>Redeemed</span>
			</div>
			<span class="redeemed-amount">{{ formattedRedeemed }}</span>
		</div>
		<div class="divider"></div>
	</div>
</template>

<script>
export default {
	name: 'RecentDiscountTransactionItem',
	props: {
		merchantName: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			required: true
		},
		faceValue: {
			type: Number,
			required: true
		},
		savedToSpendEarningsAmount: {
			type: Number,
			required: true
		},
		savingPercentage: {
			type: Number,
			required: true
		},
		usedSavedToSpend: {
			type: Number,
			default: null
		},
		formatter: {
			type: Object,
			default: () => ({ format: v => '£' + v.toFixed(2) })
		}
	},
	data() {
		return {
			imageError: false
		}
	},
	computed: {
		formattedFaceValue() {
			return this.formatter.format(this.faceValue);
		},
		formattedCashback() {
			return this.formatter.format(this.savedToSpendEarningsAmount);
		},
		formattedPercentage() {
			return this.savingPercentage.toFixed(1);
		},
		formattedRedeemed() {
			return this.formatter.format(this.usedSavedToSpend);
		}
	}
}
</script>

<style scoped>
.transaction-item {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.transaction-row {
	display: flex;
	gap: 12px;
}

.merchant-icon {
	width: 48px;
	height: 32px;
	border-radius: 4px;
	object-fit: cover;
	flex-shrink: 0;
}

.transaction-details {
	flex: 1;
}

.transaction-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.merchant-info {
	display: flex;
	flex-direction: column;
}

.merchant-name {
	font-size: 12px;
	font-weight: bold;
	color: #413655;
	margin: 0;
}

.amount-row {
	display: flex;
	gap: 4px;
}

.face-value {
	font-size: 10px;
	color: #413655;
}

.percentage {
	font-size: 10px;
	font-weight: bold;
	color: #413655;
}

.cashback-badge {
	display: flex;
	align-items: center;
	gap: 4px;
	background: #E9F7EF;
	border-radius: 4px;
	padding: 4px;
}

.cashback-icon {
	width: 14px;
	height: 14px;
	filter: invert(52%) sepia(81%) saturate(412%) hue-rotate(101deg) brightness(95%) contrast(91%);
}

.cashback-amount {
	font-size: 12px;
	font-weight: bold;
	color: #23AF64;
}

.redeemed-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: var(--background-color-main);
	border-radius: 4px;
	padding: 8px 4px;
}

.redeemed-label {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	color: #413655;
}

.redeemed-icon {
	width: 16px;
	height: 16px;
}

.redeemed-amount {
	font-size: 12px;
	color: #413655;
}

.divider {
	height: 1px;
	background: #F0F0F0;
}
</style>
